import { useState } from "react";
import Styles from "./index.module.css";
import { useRouteMatch } from "react-router-dom";
import { updateEditorValue } from "../../actions/editor";
import { useDispatch } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import getProblemForCurrentURL from "../../hooks/problem";

const EditorConfig = () => {
  const dispatch = useDispatch();
  const { params } = useRouteMatch();

  const { problemUrl } = params;
  const problemFiltered = getProblemForCurrentURL(params);
  const { starter } = problemFiltered;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className={Styles.editorConfig}>
      <Button size="sm" variant="outline-info" onClick={handleShow}>
        Instructions
      </Button>
      <Button
        size="sm"
        variant="outline-warning"
        onClick={() => {
          dispatch(
            updateEditorValue({ problemId: problemUrl, value: starter })
          );
        }}
      >
        Reset
      </Button>

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body className={Styles.instructionsText}>
          <div>
            <p>
              1. As we are executing JavaScript directly in browser, you can
              console log things and check it in the developer tools (console).
            </p>
            <p>
              2. If you end up in inifinite loop, page will be unresponsive
              (native behavior), same goes for recursion, call stack error will
              occur.
              <br />
              You can refresh the page, your code will be there, don't forget to
              update it before running again.
            </p>
            <p>
              3. It is not like you cannot change the function body, you can
              change it but make sure you return the function at the end, also
              don't forget the parameters.
            </p>
            <p>For Example:</p>
            <pre>
              const sum = (a, b) =&gt; &#123; return a + b; &#125;
              <br />
              <br />
              /*it is important to return */
              <br />
              return sum;
            </pre>
            <p>
              4. If you face any issues, you can report me on{" "}
              <a
                href="https://twitter.com/LearnersBucket"
                title="Follow on Twitter"
                target="_blank"
                rel="noreferrer"
              >
                Twitter
              </a>{" "}
              with screenshot.
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditorConfig;
